import { LoginProviderEnum } from "../enums/login-provider-enum";

export class LoginModel {
    email?: string; 
    password?: string;
    tenantId?: string;
    socialId?: string;
    loginProvider?: LoginProviderEnum;
    accessCode?: string;
}
